/** Client-side list search and sort helpers for dashboard tables. */

export function rowMatchesSearch(row: Record<string, unknown>, searchText: string, fields: string[]): boolean {
  const q = searchText.trim().toLowerCase();
  if (!q) return true;
  return fields.some((f) => String(row[f] ?? '').toLowerCase().includes(q));
}

export function sortRows<T extends Record<string, unknown>>(
  rows: T[],
  field: string,
  asc: boolean,
  numericFields: Set<string> = new Set(),
): T[] {
  const dir = asc ? 1 : -1;
  return [...rows].sort((a, b) => {
    if (numericFields.has(field)) {
      const an = Number(a[field]);
      const bn = Number(b[field]);
      const av = Number.isFinite(an) ? an : 0;
      const bv = Number.isFinite(bn) ? bn : 0;
      if (av < bv) return -1 * dir;
      if (av > bv) return 1 * dir;
      return 0;
    }
    const av = String(a[field] ?? '').toLowerCase();
    const bv = String(b[field] ?? '').toLowerCase();
    if (av < bv) return -1 * dir;
    if (av > bv) return 1 * dir;
    return 0;
  });
}

export function listSortIndicator(activeField: string, field: string, asc: boolean): string {
  if (activeField !== field) return '';
  return asc ? ' ▲' : ' ▼';
}

export function toggleListSort(
  currentField: string,
  field: string,
  currentAsc: boolean,
): { sortField: string; sortAsc: boolean } {
  if (currentField === field) {
    return { sortField: field, sortAsc: !currentAsc };
  }
  return { sortField: field, sortAsc: true };
}
